/**
 * 案件一覧へ戻る ボタン
 *
 * 詳細画面で変更があった場合にモーダルを表示する
 * 職員、申込人によって遷移先が異なる
 */
import React, { useState } from 'react';
import ModalTemplate from '../molecules/ModalTemplate';
import { return_menu_option } from '../Const';
import { editModalBody } from '../EditModal';

interface Props {
  is_staff: boolean;
  is_on_change: boolean;
}

const FooterButtonShelf: React.FC<Props> = ({ is_staff, is_on_change }) => {
  const [dialog_is_open, setDialogIsOpen] = useState(false);

  /**
   * 案件一覧に戻るボタン押下時の処理
   */
  const handleClick = () => {
    // 変更があった場合のみダイアログを開く
    is_on_change ? setDialogIsOpen(true) : handleDialogYes();
  };

  /**
   * ダイアログのはいボタン押下時の処理
   */
  const handleDialogYes = () => {
    // ダイアログを閉じる
    setDialogIsOpen(false);
    // 案件一覧に画面遷移
    window.location.href = `${location.origin}${process.env.MIX_MOCK_URL}/templates/list`;
  };

  /**
   * ダイアログのいいえボタン押下時の処理
   */
  const handleDialogNo = () => {
    // ダイアログを閉じる
    setDialogIsOpen(false);
  };

  return (
    <>
      <div>
        <a className="btn btn-main-color" onClick={handleClick}>
          案件一覧に戻る
        </a>
      </div>
      <ModalTemplate
        show={dialog_is_open}
        title={return_menu_option.modal_title}
        body={editModalBody(return_menu_option.modal_body)}
        ClickCallBackNo={() => {
          handleDialogNo();
        }}
        ClickCallBackYes={() => {
          handleDialogYes();
        }}
      />
    </>
  );
};

export default FooterButtonShelf;
